import { z } from 'zod'

import { Name } from '../../_kernel/Name'
import { BoardCode } from './BoardCode'
import { Model } from '../../_kernel/architecture'
import { BoardGroup } from './BoardGroup'

export enum BOARD_ICONS {
  IconBedAndBreakfast = 'IconBedAndBreakfast',
  IconAllInclusive = 'IconAllInclusive',
  IconLunch = 'IconLunch',
  IconLunchAndDrink = 'IconLunchAndDrink',
  IconRoomOnly = 'IconRoomOnly',
  IconSelfCatering = 'IconSelfCatering',
  IconFullKitchen = 'IconFullKitchen',
}

export const codeBoardMap = new Map([
  [
    'AB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.breakfast',
      descriptionShort: 'board-name.breakfast',
    },
  ],
  [
    'AI',
    {
      key: 'all-inclusive',
      name: 'global.all-inclusive',
      icon: BOARD_ICONS.IconAllInclusive,
      description: 'board.all-inclusive',
      descriptionShort: 'board-name.all-inclusive',
    },
  ],
  [
    'AS',
    {
      key: 'all-inclusive',
      name: 'global.all-inclusive',
      icon: BOARD_ICONS.IconAllInclusive,
      description: 'board.special-all-inclusive',
      descriptionShort: 'board-name.special-all-inclusive',
    },
  ],
  [
    'BB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.breakfast',
      descriptionShort: 'board-name.breakfast',
    },
  ],
  [
    'BH',
    {
      key: 'half-board',
      name: 'global.1-breakfast-1-half-board',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.1-breakfast-1-half-board',
      descriptionShort: 'board-name.breakfast-half-board',
    },
  ],
  [
    'CB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.continental-breakfast',
      descriptionShort: 'board-name.breakfast',
    },
  ],
  [
    'DB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.breakfast',
      descriptionShort: 'board-name.breakfast',
    },
  ],
  [
    'FB',
    {
      key: 'full-board',
      name: 'global.full-board',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.full-board',
      descriptionShort: 'board-name.full-board',
    },
  ],
  [
    'FH',
    {
      key: 'full-board',
      name: 'global.1-half-board-1-full-board',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.1-half-1-full',
      descriptionShort: 'board-name.1-half-1-full',
    },
  ],
  [
    'GB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.breakfast',
      descriptionShort: 'board-name.breakfast',
    },
  ],
  [
    'HB',
    {
      key: 'half-board',
      name: 'global.half-board',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.half-board',
      descriptionShort: 'board-name.half-board',
    },
  ],
  [
    'IB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.breakfast',
      descriptionShort: 'board-name.breakfast',
    },
  ],
  [
    'MB',
    {
      key: 'half-board',
      name: 'global.half-board-plus-beverages',
      icon: BOARD_ICONS.IconLunchAndDrink,
      description: 'board.half-board-beverages',
      descriptionShort: 'board-name.half-board-beverages',
    },
  ],
  [
    'PB',
    {
      key: 'full-board',
      name: 'global.full-board-plus-beverages',
      icon: BOARD_ICONS.IconLunchAndDrink,
      description: 'board.full-board-beverages',
      descriptionShort: 'board-name.full-board-beverages',
    },
  ],
  [
    'RO',
    {
      key: 'room-only',
      name: 'global.room-only',
      icon: BOARD_ICONS.IconRoomOnly,
      description: 'global.room-only',
      descriptionShort: 'global.room-only',
    },
  ],
  [
    'SB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.breakfast',
      descriptionShort: 'board-name.breakfast',
    },
  ],
  [
    'SC',
    {
      key: 'self-catering',
      name: 'global.self-catering',
      icon: BOARD_ICONS.IconSelfCatering,
      description: 'board.self-catering',
      descriptionShort: 'board-name.self-catering',
    },
  ],
  [
    'B1',
    {
      key: 'breakfast',
      name: 'global.breakfast-for-1',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.breakfast-for-1',
      descriptionShort: 'board-name.breakfast-for-1',
    },
  ],
  [
    'B2',
    {
      key: 'breakfast',
      name: 'global.breakfast-for-2',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.breakfast-for-2',
      descriptionShort: 'board-name.breakfast-for-2',
    },
  ],
  [
    'BD',
    {
      key: 'half-board',
      name: 'global.half-board',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.half-board',
      descriptionShort: 'board-name.half-board',
    },
  ],
  [
    'CAB',
    {
      key: 'breakfast',
      name: 'global.breakfast',
      icon: BOARD_ICONS.IconBedAndBreakfast,
      description: 'board.breakfast',
      descriptionShort: 'board-name.breakfast',
    },
  ],
  [
    'CE',
    {
      key: 'dinner',
      name: 'global.dinner',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.dinner',
      descriptionShort: 'board-name.dinner',
    },
  ],
  [
    'CO',
    {
      key: 'lunch',
      name: 'global.lunch',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.lunch',
      descriptionShort: 'board-name.lunch',
    },
  ],
  [
    'FD',
    {
      key: 'dinner',
      name: 'global.dinner',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.dinner',
      descriptionShort: 'board-name.dinner',
    },
  ],
  [
    'FK',
    {
      key: 'full-kitchen',
      name: 'global.full-kitchen',
      icon: BOARD_ICONS.IconFullKitchen,
      description: 'board.full-kitchen',
      descriptionShort: 'board-name.full-kitchen',
    },
  ],
  [
    'FL+FD',
    {
      key: 'full-board',
      name: 'global.full-board',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.full-board',
      descriptionShort: 'board-name.full-board',
    },
  ],
  [
    'TFO',
    {
      key: 'buffet',
      name: 'global.buffet',
      icon: BOARD_ICONS.IconSelfCatering,
      description: 'board.buffet',
      descriptionShort: 'board-name.buffet',
    },
  ],
  [
    'FLL',
    {
      key: 'lunch',
      name: 'global.lunch',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.lunch',
      descriptionShort: 'board-name.lunch',
    },
  ],
  [
    'SAI',
    {
      key: 'all-inclusive',
      name: 'global.soft-all-inclusive',
      icon: BOARD_ICONS.IconAllInclusive,
      description: 'board.soft-inclusive',
      descriptionShort: 'board-name.soft-all-inclusive',
    },
  ],
  [
    'BL',
    {
      key: 'half-board',
      name: 'global.half-board',
      icon: BOARD_ICONS.IconLunch,
      description: 'board.breakfast-lunch',
      descriptionShort: 'board-name.breakfast-lunch',
    },
  ],
])

export const BoardValidation = z.object({
  code: z.instanceof(BoardCode, { message: '[BoardCode] code is required' }),
  name: z.instanceof(Name, { message: '[BoardCode] name is required' }),
  group: z.instanceof(BoardGroup, { message: '[BoardGroup] group is required' }),
})

export class Board extends Model {
  static create({ code, name, group }: z.infer<typeof BoardValidation>) {
    BoardValidation.parse({ code, name, group })
    return new Board(code, name, group)
  }

  static fromJSON(json: ReturnType<Board['toJSON']>) {
    return new Board(
      BoardCode.create({ value: json.code }),
      Name.create({ value: json.name }),
      BoardGroup.fromJSON(json.group)
    )
  }

  constructor(
    private readonly _code: BoardCode,
    private readonly _name: Name,
    private readonly _group: BoardGroup
  ) {
    super()
  }

  code() {
    return this._code.value()
  }

  name() {
    return codeBoardMap.get(this._code.value())?.name
  }

  description() {
    return codeBoardMap.get(this._code.value())?.description
  }

  shortDescription() {
    return codeBoardMap.get(this._code.value())?.descriptionShort
  }

  iconName() {
    return this._code.iconName()
  }

  hasBreakfast() {
    return this._code.hasBreakfast()
  }

  isRoomOnly() {
    return this._code.isRoomOnly()
  }

  isAllInclusive() {
    return this._code.isAllInclusive()
  }

  toJSON() {
    return {
      code: this._code.value(),
      name: this._name.value,
      group: this._group.toJSON(),
    }
  }
}
